var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-header", [_c("page-head", { attrs: { isApplyPage: true } })], 1),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.pageloading,
              expression: "pageloading"
            }
          ],
          staticClass: "applybox"
        },
        [
          _c(
            "el-steps",
            {
              staticClass: "stepStyle",
              attrs: {
                active: _vm.stepActive,
                "align-center": "",
                "finish-status": "success"
              }
            },
            [
              _c("el-step", {
                attrs: { title: _vm.$t("m.agency_reginfo_fill") }
              }),
              _vm._v(" "),
              _c("el-step", { attrs: { title: _vm.$t("m.audit_res") } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "applyform" },
            [
              _vm.stepActive == 0
                ? _c("apply-form", {
                    on: { updateStepActive: _vm.updateStepActive }
                  })
                : _c("apply-result", {
                    attrs: { applyState: _vm.applyState },
                    on: { updateStepActive: _vm.updateStepActive }
                  })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09728f9d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09728f9d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/apply/index.vue
// module id = null
// module chunks = 